import angular from 'angular';
import { CheckController } from './CheckController';
import CheckView from './CheckView.html';
export const checkStateName = 'anon.check';
export const checkModule = angular
    .module('check', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state(checkStateName, {
            url: '/check',
            controllerAs: '$ctrl',
            controller: CheckController,
            template: CheckView,
            data: {
                restricted: false,
            },
            params: {
                preventRedirect: true,
                area: 'status-check',
            },
        });
    }])
    .name;
